

const defaultData = [
    {
        "key": 1,
        "name": "Veronika Pideon",
        "email": "vpideon0@house.gov",
        "phone": "+44-644-705-4009",
        "gender": "Female",
        "language": "it",
        "country": "GB",
        "idc10": "Z951",
        "data_controller": "",
        "consent_gdpr": "false",
        "consent_other": "false",
        "created_at": "2018-12-23T19:00:37.000Z"
    },
    {
        "key": 2,
        "name": "Gerardo Durbin",
        "email": "gdurbin1@ovh.net",
        "phone": "+1-515-625-4980",
        "gender": "Male",
        "language": "nl",
        "country": "US",
        "idc10": "W9301XS",
        "data_controller": "Mike",
        "consent_gdpr": "false",
        "consent_other": "false",
        "created_at": "2018-03-24T16:10:58.000Z"
    },
    {
        "key": 3,
        "name": "Elie Capineer",
        "email": "ecapineer2@tumblr.com",
        "phone": "+1-501-949-3364",
        "gender": "Female",
        "language": "sv",
        "country": "US",
        "idc10": "",
        "data_controller": "",
        "consent_gdpr": "true",
        "consent_other": "false",
        "created_at": "2019-02-13T15:31:35.000Z"
    },
    {
        "key": 4,
        "name": "Fayette Troth",
        "email": "ftroth3@princeton.edu",
        "phone": "+33-764-775-1225",
        "gender": "Female",
        "language": "it",
        "country": "FR",
        "idc10": "T84210",
        "data_controller": "",
        "consent_gdpr": "true",
        "consent_other": "true",
        "created_at": "2020-02-01T08:53:27.000Z"
    },
    {
        "key": 5,
        "name": "Sansone McGrey",
        "email": "smcgrey4@youtu.be",
        "phone": "+1-314-111-3559",
        "gender": "Male",
        "language": "fr",
        "country": "US",
        "idc10": "",
        "data_controller": "",
        "consent_gdpr": "true",
        "consent_other": "true",
        "created_at": "2019-05-15T14:43:49.000Z"
    },
    {
        "key": 6,
        "name": "Marcie Ludovico",
        "email": "mludovico5@msn.com",
        "phone": "+46-790-469-1790",
        "gender": "Female",
        "language": "sv",
        "country": "SE",
        "idc10": "",
        "data_controller": "",
        "consent_gdpr": "true",
        "consent_other": "false",
        "created_at": "2019-01-06T06:58:01.000Z"
    },
    {
        "key": 7,
        "name": "Barret Faire",
        "email": "bfaire6@xrea.com",
        "phone": "+46-266-109-6985",
        "gender": "Male",
        "language": "fr",
        "country": "SE",
        "idc10": "M84345",
        "data_controller": "",
        "consent_gdpr": "false",
        "consent_other": "true",
        "created_at": "2020-06-28T06:30:20.000Z"
    },
    {
        "key": 8,
        "name": "Trey Shory",
        "email": "tshory7@imgur.com",
        "phone": "+1-419-782-6416",
        "gender": "Male",
        "language": "sv",
        "country": "US",
        "idc10": "",
        "data_controller": "",
        "consent_gdpr": "true",
        "consent_other": "false",
        "created_at": "2019-02-24T19:40:58.000Z"
    },
    {
        "key": 9,
        "name": "Kamillah Bellhouse",
        "email": "kbellhouse8@feedburner.com",
        "phone": "+33-655-648-1453",
        "gender": "Female",
        "language": "en",
        "country": "FR",
        "idc10": "V4919",
        "data_controller": "",
        "consent_gdpr": "false",
        "consent_other": "false",
        "created_at": "2018-12-07T19:34:20.000Z"
    },
    {
        "key": 10,
        "name": "Irvine Haseldine",
        "email": "",
        "phone": "+33-419-491-9673",
        "gender": "Male",
        "language": "fr",
        "country": "",
        "idc10": "",
        "data_controller": "",
        "consent_gdpr": "true",
        "consent_other": "true",
        "created_at": "2020-01-23T21:18:56.000Z"
    }]

export default defaultData;